import React, { FC } from "react"
import { useSelector } from "react-redux"

import FormikBootstrap from "@/components/formik-bootstrap"
import { getFeatures, getProduct } from "@/onboarding/features/product/selectors"

const ComponentOperatorSelect: FC = () => {
  const features = useSelector(getFeatures)
  const { seasonOperators: options } = useSelector(getProduct)

  return (
    <FormikBootstrap.SingleSelect
      name="operatorId"
      label="Operator"
      options={options}
      disabled={!features.general.product.assignComponentOperators}
    />
  )
}

export default ComponentOperatorSelect
